/** Default quality for all next/image optimizations. */
export const NEXT_IMAGE_QUALITY = 65
